

import { ReactComponent as Logo } from "assets/logo_original_colored.svg";
import { ReactComponent as BlueLogo } from "assets/logo_original_dark.svg";

import About from "./about/About";
import Investment from "./investment/Investment";
import Leadership from "./leadership/leadership";
import Culture from "./culture/culture";

import React, { useEffect, useRef, useState } from "react";
import "./styles.css";
import useWindowDimensions from "components/utils/useWindowDimensions";

import img_about_bg from "assets/about_bg.svg";
import img_homepage_bg from "assets/homepage_bg.png";
import img_leadership_bg from "assets/leadership_bg.svg";
import img_investmentapproach_img from "assets/investmentapproach_img.svg";
import img_logo_original from "assets/logo_original.svg";
import img_intro_bg from "assets/intro_bg.svg";
import img_culture_img from "assets/culture_img.svg";
import img_drawerLogo from "assets/drawerLogo.svg";
import logoGif from "assets/newgif.png";
import Mobileinvestement from "./investment/Mobileinvestement";

const Preloader = () => (
  <div className="flex justify-center w-full h-lvh items-center bg-loader-mobile">
   <div className="loader-container">
  <div className="loader-wrapper">
    <img src={logoGif} alt="Loading..." className="preloader-logo" />
    <div className="loader-spinner"></div>
  </div>
</div>



  </div>
);

export default function HomeMobile(props) {
  const { height, width } = useWindowDimensions();
  const isMobileView = width < 767;

  const [currentSection, setCurrentSection] = useState(3); // Start from section-3
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [scrollY, setScrollY] = useState(0);
  const [showBlueLogo, setShowBlueLogo] = useState(false);
  const [progressHeight, setProgressHeight] = useState(0);

  const homeRef = useRef({
    MIN_SECTIONS: 3, // Set min section to 3
    MAX_SECTIONS: 6,
    timeoutInstance: null,
    clientY: 0,
  });

  const imageUrls = [
    img_investmentapproach_img,
    img_about_bg,
    img_homepage_bg,
    img_leadership_bg,
    img_logo_original,
    img_intro_bg,
    img_culture_img,
    img_drawerLogo,
  ];

  useEffect(() => {
    let images = [];
    let loadedImages = 0;

  const onImageLoad = () => {
    loadedImages++;
    if (loadedImages === imageUrls.length) {
      setTimeout(() => {
        setImagesLoaded(true);
      }, 4000); // Delay for 5 seconds
    }
  };

    imageUrls.forEach((url) => {
      const img = new Image();
      img.onload = onImageLoad;
      img.src = url;
      images.push(img);
    });

    return () => {
      images.forEach((img) => (img.onload = null));
    };
  }, []);

  useEffect(() => {
    if (currentSection === 3) {
      setProgressHeight(0);
    } else {
      let progress = (currentSection - 3) / (homeRef.current.MAX_SECTIONS - 3);
      setProgressHeight(progress * height);
    }
  }, [currentSection, height]);

  useEffect(() => {
    setShowBlueLogo(currentSection > 3);
  }, [scrollY, currentSection]);

  const handleNavigation = (direction) => {
    setCurrentSection((prev) => {
      const newSection =
        direction > 0
          ? Math.min(prev + 1, homeRef.current.MAX_SECTIONS)
          : Math.max(prev - 1, homeRef.current.MIN_SECTIONS);

      setShowBlueLogo(newSection > 3);
      return newSection;
    });
  };

  const handleWheelChange = (event) => {
    if (currentSection === 4 || currentSection === 6) {
      return;
    }

    if (homeRef.current.timeoutInstance) {
      clearTimeout(homeRef.current.timeoutInstance);
    }
    homeRef.current.timeoutInstance = setTimeout(() => {
      handleNavigation(event.deltaY > 0 ? 1 : -1);
    }, 500);
  };

  const handleTouchEnd = (e) => {
    let deltaY = e.changedTouches[0].clientY - homeRef.current.clientY;
    handleWheelChange({ deltaY: -deltaY });
  };

  const handleTouchStart = (e) => {
    homeRef.current.clientY = e.touches[0].clientY;
  };

  const LogoComponent = () =>
    showBlueLogo ? <BlueLogo id="logo" style={{ cursor: "pointer", width: "50%", top: "6px" }} /> : <Logo id="logo" style={{ cursor: "pointer", width: "50%" ,top:"5px" }} />;

  if (!imagesLoaded) return <Preloader />;

  return (
    <>
      <div
        className="progress-bar"
        style={{
          height: progressHeight,
          transition: "height 0.5s ease-out",
        }}
      />
      <div onTouchStart={handleTouchStart} onTouchEnd={handleTouchEnd} onWheel={handleWheelChange} className={`home-container section-${currentSection}`}>
        <header className="header">
          <div
            className="inner-content"
            onClick={() => {
              props.toggleDrawer();
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" width="57" height="21" viewBox="0 0 57 21" fill="none">
              <rect width="57" height="1.09524" fill="#323131" />
              <rect y="9.95312" width="57" height="1.09524" fill="#323131" />
              <rect y="19.9043" width="57" height="1.09524" fill="#323131" />
            </svg>
            
          </div>
           <LogoComponent />
        </header>
        <main>
          {isMobileView && currentSection >= 3 && (
            <section id="section-3" className={`sec-content ${currentSection >= 3 ? "active-section" : ""}`}>
              <div className="mobile-view-div">
                <div className="background-mobile-img flex flex-col justify-center items-center text-center">
                  <div className="inner-content p-1">
                    <h1 className="text-[36px] font-primary text-white leading-[1]">
                      Investment Leader, Diverse <br />
                      Strategies Worldwide
                    </h1>
                    <p className="text-[16px] text-white mt-4" style={{ fontFamily: "NickySans" }}>
                      We aim to democratize hedge fund access, offering transparent, AI-driven strategies for benchmark-beating returns.
                    </p>
                  </div>
                </div>
                <About />
                <Mobileinvestement />
                <Leadership />
                <Culture />
              </div>
            </section>
          )}
        </main>
      </div>
    </>
  );
}
